import Vue from 'vue';
import inputLimitEn from 'common-module/src/input-limit/index-en';
import inputLimit from 'common-module/src/input-limit/index';
import i18n from 'common-module/src/lang';

const inputLimitFreeze = Object.freeze(inputLimit);
const inputLimitFreezeEn = Object.freeze(inputLimitEn);
const proxy = new Proxy({}, {
  get (target, p) {
    return i18n.locale === 'zh' ? inputLimitFreeze[p] : inputLimitFreezeEn[p];
  }
});
Vue.prototype.$inputLimit = proxy;
// 部分输入框当超过20个字符时候会转换为textarea
Vue.prototype.$inputMaxLength = 20;